import {
  MAP_SELECT_TREE,
  MAP_TOGGLE_TREE_SELECTION,
  MAP_CLEAR_SELECTION,
  MAP_SET_SIDEBAR_TAB,
  MAP_TOGGLE_SIDEBAR,
  MAP_SET_SIDEBAR,
  MAP_SET_PLACE_MODE,
  MAP_SET_SITE_PICK_MODE,
  MAP_SET_SELECTION_MODE,
  MAP_SET_LAST_TREE_DRAFT,
} from '../actions';
import { isMobileViewport } from '../../utils/viewport';

const INIT_STATE = {
  selected_tree_id: null,
  selected_tree_ids: [],
  sidebar_open: typeof window !== 'undefined' ? !isMobileViewport() : true,
  sidebar_tab: 'sites',
  place_mode: false,
  site_pick_mode: false,
  selection_mode: false,
  last_tree_draft: null,
};

export default function mapReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case MAP_SELECT_TREE.REQUEST:
      return { ...state, selected_tree_id: action.payload?.tree_id ?? null };
    case MAP_TOGGLE_TREE_SELECTION.REQUEST: {
      const id = action.payload?.tree_id;
      const ids = new Set(state.selected_tree_ids);
      if (ids.has(id)) ids.delete(id);
      else ids.add(id);
      return { ...state, selected_tree_ids: Array.from(ids) };
    }
    case MAP_CLEAR_SELECTION.REQUEST:
      return { ...state, selected_tree_ids: [], selected_tree_id: null, selection_mode: false };
    case MAP_SET_SIDEBAR_TAB.REQUEST:
      return { ...state, sidebar_tab: action.payload?.tab ?? 'sites' };
    case MAP_TOGGLE_SIDEBAR.REQUEST:
      return { ...state, sidebar_open: !state.sidebar_open };
    case MAP_SET_SIDEBAR.REQUEST:
      return { ...state, sidebar_open: Boolean(action.payload?.open) };
    case MAP_SET_PLACE_MODE.REQUEST:
      return {
        ...state,
        place_mode: Boolean(action.payload?.enabled),
        site_pick_mode: action.payload?.enabled ? false : state.site_pick_mode,
        selection_mode: action.payload?.enabled ? false : state.selection_mode,
      };
    case MAP_SET_SITE_PICK_MODE.REQUEST:
      return {
        ...state,
        site_pick_mode: Boolean(action.payload?.enabled),
        place_mode: action.payload?.enabled ? false : state.place_mode,
        selection_mode: action.payload?.enabled ? false : state.selection_mode,
      };
    case MAP_SET_SELECTION_MODE.REQUEST:
      return {
        ...state,
        selection_mode: Boolean(action.payload?.enabled),
        place_mode: action.payload?.enabled ? false : state.place_mode,
      };
    case MAP_SET_LAST_TREE_DRAFT.REQUEST:
      return { ...state, last_tree_draft: action.payload };
    default:
      return state;
  }
}
